var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDeviceMessage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25 8.26001C27.0676 8.26001 28.7499 9.91909 28.75 11.9797V22.8899C28.75 24.939 27.0693 26.6096 25 26.6096H24.2402C23.6351 26.6096 23.0668 26.8437 22.6504 27.26L22.6475 27.2629L20.9375 28.9534H20.9365C19.8644 30.0117 18.1248 30.0117 17.0527 28.9534L15.3428 27.2629L15.3398 27.26C14.9243 26.8445 14.3466 26.6096 13.75 26.6096H13C10.9324 26.6096 9.25 24.9506 9.25 22.8899V11.9797C9.25013 9.91909 10.9324 8.26001 13 8.26001H25Z",
    stroke: "#32174E",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14 16.1598C14 15.2298 14.76 14.4697 15.69 14.4697C16.62 14.4697 17.38 15.2298 17.38 16.1598C17.38 18.0398 14.71 18.2398 14.12 20.0298C14 20.3998 14.31 20.7698 14.7 20.7698H17.38",
    stroke: "#32174E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.04 20.7599V15.0499C23.04 14.7899 22.87 14.5598 22.62 14.4898C22.37 14.4198 22.1 14.5198 21.96 14.7398C21.24 15.8998 20.46 17.2199 19.78 18.3799C19.67 18.5699 19.67 18.8199 19.78 19.0099C19.89 19.1999 20.1 19.3198 20.33 19.3198H24",
    stroke: "#32174E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeviceMessage);
export default __webpack_public_path__ + "static/media/device-message.9bd010d98577150f7a390d21f77ed005.svg";
export { ForwardRef as ReactComponent };